<template>
  <div>
    <ion-app>
      <ion-router-outlet />
    </ion-app>
  </div>
</template>

<script>
import {IonApp} from '@ionic/vue';
import {defineComponent} from 'vue';
import {IonRouterOutlet} from '@ionic/vue';
import FCMservice from './/services/fcm';
import {getPlatforms} from '@ionic/vue';

export default defineComponent({
    name: 'App',
    components: {
        IonApp,
        IonRouterOutlet,
    },
    computed: {
        isLogin() {
            return this.$route.name === 'Login' || this.$route.name === 'SetPassword';
        },
        allAccepted() {
            return true;
            // return this.$store.getters.allDocumentsAccepted;
        },
    },
    mounted() {
        // if Platform is iOS, ask for permission to send Push Notifications, but only if not in browser or desktop
        if (getPlatforms().includes('ios') && !getPlatforms().includes('mobileweb') && !getPlatforms().includes('desktop')) {
            FCMservice.getPermission();
        }
    },
});
</script>

<style>
ion-content {
  --keyboard-offset: 0px;
}
</style>
